import { Form, Input } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import SensitiveInput from '../SensitiveInput'
import InstantSwitch from '../InstantSwitch'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['SMTPServer', 'SMTPPort', 'SMTPAccount', 'SMTPFrom', 'SMTPToken', 'SMTPSSLEnabled']

export default function SMTPSection({ options }: { options: OptionsAPI }) {
  const { get, patch } = options

  return (
    <SettingSectionCard title="SMTP 邮件" subtitle="系统邮件发送配置" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="SMTP 服务器">
            <Input value={get('SMTPServer')} onChange={(v) => patch({ SMTPServer: v })} />
          </Form.Item>
          <Form.Item label="SMTP 端口">
            <Input value={get('SMTPPort')} onChange={(v) => patch({ SMTPPort: v })} />
          </Form.Item>
          <Form.Item label="SMTP 账户">
            <Input value={get('SMTPAccount')} onChange={(v) => patch({ SMTPAccount: v })} />
          </Form.Item>
          <Form.Item label="发件人邮箱">
            <Input value={get('SMTPFrom')} onChange={(v) => patch({ SMTPFrom: v })} />
          </Form.Item>
          <Form.Item label="SMTP 访问凭证">
            <SensitiveInput value={get('SMTPToken')} onChange={(v) => patch({ SMTPToken: v })} />
          </Form.Item>
          <Form.Item label="启用 SMTP SSL">
            <InstantSwitch options={options} optionKey="SMTPSSLEnabled" />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
